import { useAppSelector } from "../store/store";
const useHasPermission = () => {
    const { role, rolePermissions } = useAppSelector((state) => state.userFlow);
  
    const hasPermission = (permissionKey: keyof ITilePermissions): boolean => {
      if (!role || !rolePermissions[role]) return false;
      return rolePermissions[role][permissionKey] ?? false;
    };
  
    return { hasPermission };
  };
  export default useHasPermission;